import {
    Activity,
    FileText,
    Mail,
    Send,
    Users,
} from "lucide-react";
import { formatRel } from "@/components/Admin/format";

export default function StatsRow({ stats, webhookLog, emailLog }) {
    const hasFailedDelivery =
        webhookLog[0]?.delivered === false || emailLog[0]?.delivered === false;
    const totalAttempts = webhookLog.length + emailLog.length;

    return (
        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
            <StatCard
                icon={Users}
                label="Demo requests"
                value={stats?.demo_requests ?? "—"}
                sub={
                    stats?.last_demo_at
                        ? `Last: ${formatRel(stats.last_demo_at)}`
                        : "No submissions yet"
                }
            />
            <StatCard
                icon={FileText}
                label="Capability downloads"
                value={stats?.capability_requests ?? "—"}
                sub={
                    stats?.last_capability_at
                        ? `Last: ${formatRel(stats.last_capability_at)}`
                        : "No downloads yet"
                }
            />
            <StatCard
                icon={Mail}
                label="Lead email"
                value={stats?.email_configured ? "Routing on" : "Not set"}
                sub={
                    stats?.notify_email
                        ? `→ ${stats.notify_email}`
                        : "Set NOTIFY_EMAIL + SMTP_* in .env"
                }
                accent={stats?.email_configured}
                warn={
                    Boolean(stats) &&
                    !stats.email_configured &&
                    Boolean(stats.notify_email)
                }
            />
            <StatCard
                icon={Send}
                label="Webhook URL"
                value={stats?.webhook_configured ? "Configured" : "Not set"}
                sub={
                    stats?.webhook_secret_configured
                        ? "HMAC signing on"
                        : "No HMAC signing"
                }
                accent={stats?.webhook_configured}
            />
            <StatCard
                icon={Activity}
                label="Recent deliveries"
                value={totalAttempts}
                sub={
                    hasFailedDelivery
                        ? "Most recent attempt failed"
                        : totalAttempts > 0
                          ? "All recent attempts ok"
                          : "No attempts logged"
                }
                warn={hasFailedDelivery}
            />
        </section>
    );
}

function StatCard({ icon: Icon, label, value, sub, accent, warn }) {
    return (
        <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5">
            <div className="flex items-center justify-between">
                <span className="text-[10px] uppercase tracking-widest text-zinc-400">
                    {label}
                </span>
                <Icon
                    className={`w-4 h-4 ${
                        warn
                            ? "text-[#F59E0B]"
                            : accent
                              ? "text-[#10B981]"
                              : "text-[#1FA8FF]"
                    }`}
                />
            </div>
            <div className="mt-2 font-display text-3xl text-white font-mono-tab">
                {value}
            </div>
            <div className="mt-1 text-xs text-zinc-500">{sub}</div>
        </div>
    );
}
